import styles from './style.postcss';

import React, { Component } from 'react';
import { Button, Icon, testClass } from 'omni-common-ui';
import { Link } from 'react-router';
import is from 'is_js';
import classnames from 'classnames';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import PropTypes from 'prop-types';

class BaseSessionNav extends Component {
  // these methods are overridden by the implementing class!
  /* eslint-disable class-methods-use-this */

  _hasNext() {
    return true;
  }

  _hasPrevious() {
    return true;
  }

  _hasNextUnit() {
    return true;
  }

  _hasPreviousUnit() {
    return true;
  }

  _getHeadingText() {
    return 'Heading Text';
  }

  _getAdditionalChildren() {
    return <div />;
  }

  _getNextUnitText() {
    return 'NEXT';
  }

  _getPreviousUnitText() {
    return 'PREVIOUS';
  }

  _renderPreviousButton() {
    const className = classnames(styles.BaseSessionNav_previous,
        { [styles.__disabled]: ! this._hasPrevious() });

    const wrapperClassName = classnames(testClass('nav-previous'), {
      [styles.BaseSessionNav_disabled]: ! this._hasPrevious(),
    });

    return <span className={wrapperClassName}>
      <Link className={className}
          to={this.props.previousSessionLinkHref}
          draggable={false}>
        <Icon id="chevron-thin-left" />
      </Link>
    </span>;
  }

  _renderPreviousUnit() {
    if (! this.props.showUnitNav) {
      return null;
    }

    const isFirst = this._hasPreviousUnit() !== true;
    const isLast = this._hasNextUnit() !== true;
    const className = classnames(styles.BaseSessionNav_units_btn,
      styles.__previous,
      {
        [styles.__isLast]: isLast,
      });

    return <Button className={className}
        type={Button.Type.default}
        disabled={isFirst}
        linkTo={this.props.previousUnitLinkHref}>
      <Icon id="chevron-small-left" />
      {isFirst || this._getPreviousUnitText()}
    </Button>;
  }

  _renderNextButton() {
    const className = classnames(styles.BaseSessionNav_next,
        { [styles.__disabled]: ! this._hasNext() });

    const wrapperClassName = classnames(testClass('nav-next'), {
      [styles.BaseSessionNav_disabled]: ! this._hasNext(),
    });

    return <span className={wrapperClassName}>
      <Link className={className}
          to={this.props.nextSessionLinkHref}
          draggable={false}>
        <Icon id="chevron-thin-right" />
      </Link>
    </span>;
  }

  _renderNextUnit() {
    if (! this.props.showUnitNav) {
      return null;
    }

    const isLast = this._hasNextUnit() !== true;
    const classes = classnames(styles.BaseSessionNav_units_btn,
        styles.__next);

    return <Button className={classes}
        type={Button.Type.default}
        disabled={isLast}
        linkTo={this.props.nextUnitLinkHref}>
      {isLast || this._getNextUnitText()}
      <Icon id="chevron-small-right" />
    </Button>;
  }

  _renderUnits() {
    return <div className={styles.BaseSessionNav_units}>
      {this._renderPreviousUnit()}
      {this._renderNextUnit()}
    </div>;
  }

  _renderCurrent() {
    return <div className={classnames(styles.BaseSessionNav_current, {
      [styles.__populated]: !! this.props.showCurrentNav,
    })}>
      {
        is.existy(this.props.currentLinkHref) ?
          <Button linkTo={this.props.currentLinkHref} type={Button.Type.primary}>
            Current
          </Button> : null
      }
    </div>;
  }

  _renderUnitSessionNavigation() {
    return <div className={styles.BaseSessionNav}>
      {this._renderCurrent()}
      <nav className={styles.BaseSessionNav_navigator}>
        {this._renderPreviousButton()}
        <div className={styles.BaseSessionNav_content}>
          <div className={styles.BaseSessionNav_content_line}>
            <h1 className={styles.BaseSessionNav_content_line_heading}>
              {this._getHeadingText()}
            </h1>
            {this._getAdditionalChildren()}
          </div>
        </div>
        {this._renderNextButton()}
      </nav>
      {this._renderUnits()}
    </div>;
  }

  render() {
    const { sessionNav: settings } = BaseSessionNav.getCurrentRouteSegment(this.props) || {};
    if (settings && settings.hidden === true) {
      return null;
    }

    return <CSSTransitionGroup transitionName="session-nav" transitionAppear>
      {
        ((! settings || ! settings.noUnitSessionNavigation) && ! this.props.isHide) &&
        <div className={styles.BaseSessionNav_navWrapper}>
          {this._renderUnitSessionNavigation()}
        </div>
      }
    </CSSTransitionGroup>;
  }
}

BaseSessionNav.getCurrentRouteSegment = (props) =>
  props.routes && props.routes[props.routes.length - 1];

BaseSessionNav.propTypes = {
  routes: PropTypes.array,
  showCurrentNav: PropTypes.bool,
  showUnitNav: PropTypes.bool,
  isHide: PropTypes.bool,
  nextSessionLinkHref: PropTypes.string,
  previousSessionLinkHref: PropTypes.string,
  nextUnitLinkHref: PropTypes.string,
  previousUnitLinkHref: PropTypes.string,
  currentLinkHref: PropTypes.string,
  buildRoute: PropTypes.func.isRequired,
};

export default BaseSessionNav;



// WEBPACK FOOTER //
// ./components/BaseSessionNav/index.jsx